import { Typography, Box, Button, styled } from "@mui/material";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";

const uiFont = appThemeFonts.family.ui;

export const StyledContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  flexShrink: 0,
  marginBottom: "10px",
  fontFamily: uiFont,
  height: '38px'
}));

export const StyledTitleBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "12px",
  alignItems: "center",
  minWidth: 0,
}));

export const IconContainer = styled(Box)(() => ({
  width: "24px",
  height: "24px",
  borderRadius: "7px",
  backgroundColor: appThemeColors.background.selected,
  color: appThemeColors.text.lightBlue,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  "& svg": {
    width: "14px",
    height: "14px",
    fontSize: "14px",
  },
}));

export const TextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
}));

export const StyledHeading = styled(Typography)(() => ({
  fontFamily: uiFont,
  fontSize: appThemeFonts.size.xl,
  fontWeight: "700",
  color: appThemeColors.text.heading,
}));

export const StyledSubHeading = styled(Typography)(() => ({
  fontFamily: uiFont,
  fontSize: appThemeFonts.size.basePlus,
  color: appThemeColors.text.muted,
  marginTop: "3px",
}));

export const ActionsContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "24px",
  marginLeft: "auto",
  minWidth: 0,
}));

export const StyledButton = styled(Button)(() => ({
  height: "38px",
  padding: "0px 18px",
  backgroundColor: appThemeColors.text.lightBlue,
  borderRadius: "22px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: uiFont,
  fontSize: appThemeFonts.size.base,
  fontWeight: "600",
  color: appThemeColors.neutral.white,
  "&:hover": {
    boxShadow: "none",
    backgroundColor: appThemeColors.text.heading,
  },
}));
